import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";
import { useApp } from "../../contexts/AppContext";

function useMemberPermissions() {
  const { organizationId } = useApp();

  const basePath = useMemo(() => {
    return `${organizationId}/user-permission`;
  }, [organizationId]);

  return {
    getMemberPermissions: (payload) =>
      apiInstance.post(basePath + "/get", payload),
    updateMemberPermissions: (payload) => apiInstance.put(basePath, payload),
  };
}

export default useMemberPermissions;
